/* eslint-disable react/jsx-props-no-spreading */
import { Button, ButtonProps as MantineCoreButtonProps } from "@mantine/core"; // Alias to avoid any potential global ButtonProps conflicts
import React from 'react'; // For JSX.Element

const MButton = (props: MantineCoreButtonProps): JSX.Element => {
    const { color, variant } = props;
    return (
        <Button {...props} variant={color || variant || "default"} />
    );
};

export default MButton;
